import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Form as BootstrapForm } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  collectionEditAction,
  collectioncreateAction,
  collectiondetailsAction,
  collectionlistAction,
} from "../Redux/Action/CollectionAction";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import CollectionImagesModal from "./CollectionImagesModal";
import AccessTypeSelect from "../Components/common/AccessTypeSelect";

const CreateCollectionModal = ({
  showCollection,
  handleCloseCollection,
  setValue,
  value,
  handleDeleteOpen,
  editData,
  type,
  shortContainerRef,
}) => {
  const dispatch = useDispatch();
  const [Modalshow, setModalshow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSlectedImage] = useState("");

  const intialData = {
    name: "",
    image: "",
    accessType: "PUBLIC",
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("This field is required")
      .min(5, "Title must be at least 5 characters")
      .max(50, "Title cannot be longer than 50 characters"),
    accessType: Yup.string().required("type is required"),
  });

  const handleOpenColImgModal = () => {
    setModalshow(true);
  };

  const formik = useFormik({
    initialValues: editData || intialData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      if (editData?._id) {
        setIsLoading(true);
        const ModifyData = {
          id: values._id,
          name: values.name,
          accessType: values?.accessType,
          image: selectedImage || values.image,
        };
        const response = await dispatch(collectionEditAction(ModifyData));
        if (response?.payload?.statusCode === 200) {
          toast.success(response?.payload?.message, {
            iconTheme: { primary: "#4318ff", secondary: "#FFFAEE" },
          });
          setIsLoading(false);
          setSubmitting(false);
          handleCloseCollection();
          dispatch(collectiondetailsAction(editData?._id));
          dispatch(collectionlistAction({ searchValue: "" }));
          formik.resetForm();
          setTimeout(() => setSlectedImage(""), 1000);
        } else {
          toast.error(response?.payload?.message);
          setIsLoading(false);
        }
      } else {
        setIsLoading(true);
        const Payload = {
          id: values._id,
          name: values.name,
          accessType: values?.accessType,
          image: selectedImage || values.image,
        };
        const response = await dispatch(collectioncreateAction(Payload));
        if (response?.payload?.statusCode === 200) {
          toast.success(response?.payload?.message, {
            iconTheme: { primary: "#4318ff", secondary: "#FFFAEE" },
          });
          setIsLoading(false);
          setSubmitting(false);
          handleCloseCollection();
          dispatch(collectionlistAction({ searchValue: "" }));
          formik.resetForm();
          setTimeout(() => setSlectedImage(""), 1000);
        } else {
          toast.error(response?.payload?.message);
          setIsLoading(false);
        }
      }
    },
  });

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <div className="select-type-access-style">
        <span className="small">
          While learners can only ever see Collections that explicitly you’ve
          shared with them, adjusting the Privacy Level will control whether
          other Staff in your organisation can see this Collection. This can be
          helpful when supporting learners with sensitive issues. Please note
          that your organisation’s Super Administrator can always see all
          Collections, regardless of their Privacy Level.
        </span>
      </div>
    </Tooltip>
  );

  return (
    <>
      <Modal
        size="lg"
        show={showCollection}
        onHide={handleCloseCollection}
        className="comn-modal-set"
        container={shortContainerRef?.current}
      >
        <Modal.Header className="d-block" style={{ border: "0" }}>
          <Row>
            <Col lg={12} className="d-flex justify-content-center ">
              <div>
                <Modal.Title>
                  {type === "CreateCollection"
                    ? "Add Collection"
                    : "Edit Collection"}
                </Modal.Title>
                <p className="text-center mb-0">
                  {type === "CreateCollection"
                    ? "Add your collection name and image"
                    : "Edit your collection name and image"}
                </p>
              </div>
            </Col>
          </Row>
          <div className="modal-right">
            <button className="menu-dots" onClick={handleCloseCollection}>
              <img
                src={require("../Assets/Images/dotsweb.svg").default}
                alt="dots"
              />
            </button>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="collection-sec">
            <Row className="justify-content-center">
              <Col lg={9}>
                <form onSubmit={formik.handleSubmit}>
                  <BootstrapForm.Group
                    className="mb-3"
                    controlId="collectionName"
                  >
                    <BootstrapForm.Label>Collection Name</BootstrapForm.Label>
                    <input
                      type="text"
                      name="name"
                      className="form-control input-set"
                      placeholder="Type Here"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="text-danger">{formik.errors.name}</div>
                    )}
                  </BootstrapForm.Group>

                  <div className="image-upload-main">
                    <Row>
                      <Col lg={7}>
                        <div className="image-upload-show">
                          {formik.values.image || selectedImage ? (
                            <img
                              className="upload-prev"
                              src={selectedImage || formik.values.image}
                              alt="Selected"
                            />
                          ) : (
                            <div
                              className="popup-upld-send"
                              onClick={handleOpenColImgModal}
                            >
                              <img
                                src={require("../Assets/Images/upload-pop.png")}
                                alt="default uploader"
                              />
                              <h2>Choose Image </h2>
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col lg={5} className="d-flex align-items-end">
                        <div className="upload-desc">
                          <h3>Choose Image </h3>
                          <p>
                            Chose an image for <br />
                            your collection
                          </p>
                          <Button
                            variant="primary"
                            className="modal-f-btn"
                            onClick={handleOpenColImgModal}
                          >
                            {selectedImage || formik.values.image
                              ? "Update"
                              : "Choose"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <BootstrapForm.Group className="mb-3 mt-3">
                    <BootstrapForm.Label>
                      {" "}
                      <div className="privacy-head d-flex gap-2">
                        <h3 className="m-0">Privacy Level</h3>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip}
                        >
                          <span
                            style={{ cursor: "pointer", color: "#666" }}
                            className="mt-2"
                          >
                            <FaInfoCircle size={20} />
                          </span>
                        </OverlayTrigger>
                      </div>{" "}
                    </BootstrapForm.Label>
                    {/* <div className="privacy-desc">
                      <p>
                        While learners can only ever see Collections that
                        explicitly you’ve shared with them, adjusting the
                        Privacy Level will control whether other Staff in your
                        organisation can see this Collection. This can be
                        helpful when supporting learners with sensitive issues.
                        Please note that your organisation’s Super Administrator
                        can always see all Collections, regardless of their
                        Privacy Level.
                      </p>{" "}
                    </div> */}
                    <AccessTypeSelect formik={formik} />
                    {formik.touched.accessType && formik.errors.accessType && (
                      <div className="text-danger">
                        {formik.errors.accessType}
                      </div>
                    )}
                  </BootstrapForm.Group>

                  <Modal.Footer className="border-none justify-content-center ">
                    <Button
                      variant="primary"
                      className="modal-f-btn"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Save"}
                    </Button>
                    {type === "DetailCollection" && (
                      <Button
                        variant="primary"
                        className="modal-f-btn"
                        type="button"
                        onClick={handleDeleteOpen}
                      >
                        Delete
                      </Button>
                    )}
                  </Modal.Footer>
                </form>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <CollectionImagesModal
        Modalshow={Modalshow}
        handleCloseColImgModal={() => setModalshow(false)}
        setSlectedImage={setSlectedImage}
        shortContainerRef={shortContainerRef}
      />
    </>
  );
};

export default CreateCollectionModal;
